// extracted by mini-css-extract-plugin
export default {"MNPFormWrapper":"MNPForm_MNPFormWrapper__KphZr","MNPFormDetails":"MNPForm_MNPFormDetails__ZBpr0","required":"MNPForm_required__zYG+G"};